///<reference path="../../../../../../node_modules/rxjs/add/operator/toPromise.d.ts"/>
import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import {RegionsResponse} from '../../interfaces/RegionsResponse';
import {Region} from '../../interfaces/Region';
import {ErrorService} from '../../../utilities/services/error/error.service';

@Injectable()
export class RegionService {
  private endpoint = 'regions';
  constructor(private http: AuthHttp, public errorDialogService: ErrorService) { }

  /**
   * Retrieves a paginated list of regions
   * @param {number} limit
   * @param {number} page
   * @param {string} search
   * @param {string} orderBy
   * @param {string} direction
   * @returns {Promise<RegionsResponse>}
   */
  public getRegions(limit: number = 10, page = 1, search = '', orderBy = 'name', direction = 'asc'): Promise<RegionsResponse> {
    const url = `${environment.baseUrl}${this.endpoint}?limit=${limit}&page=${page}&search=${search}&orderBy=${orderBy}&direction=${direction}`;
    return this.http.get(url).map(res => res.json()).toPromise()
  }

  public getRegion(id): Promise<Region> {
    const url = `${environment.baseUrl}${this.endpoint}/${id}`;
    return this.http.get(url).map(res => res.json()).toPromise()
  }

  /**
   * Creates a new region
   * @param data
   * @returns {Promise<Region>}
   */
  public create(data): Promise<Region> {
    const url = `${environment.baseUrl}${this.endpoint}`;
    return this.http
      .post(url, data)
      .map(res => res.json())
      .toPromise()
      .catch(error => this.handleError(error));
  }

  /**
   * Updates a region
   * @param id
   * @param data
   * @returns {Promise<Region>}
   */
  public update(id, data): Promise<Region> {
    const url = `${environment.baseUrl}${this.endpoint}/${id}`;
    return this.http
      .put(url, data)
      .map(res => res.json())
      .toPromise()
      .catch(error => this.handleError(error));
  }

  /**
   * Destroys a regions
   * @param id
   * @returns Promise
   */
  public delete(id) {
    const url = `${environment.baseUrl}${this.endpoint}/${id}`;
    return this.http.delete(url).map(res => res.json()).toPromise();
  }

  private handleError(error: Response) {
    this.errorDialogService.openDialog(error);
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/region/services/region/region.service.ts